import { FileItem } from "ng2-file-upload";
import { CitationAvailability } from "../../link-access/shared/citation-availability";
import { EntityType } from "../../shared/shared/entity-type.enum";
import { CopyrightLicense } from "./copyright-license";

export class RlFile{
    amazonFileKey : string;
    amazonDisplayFileName : string;
    fileSize? : number;
    entityType? : EntityType | string;
    entityId? : string;
    url? : string;
    fileItem? : FileItem;
    itemLocked? : boolean =false;
    allowAnnotations? : boolean = false;
    _results? : string;    
    errors? : any[];
    title? : string;
    listName? : string;
    sectionName? : string;
    availabilityConf : CitationAvailability;
    type : FileType = "AMAZON";
    license : CopyrightLicense;
    sanitizeFile : boolean;
    set results(res : string){
        this._results = res;
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(res,"text/xml");
        this.url = xmlDoc.getElementsByTagName("Location")[0].childNodes[0].nodeValue;
    }

    constructor(){}

    data = () => ({ amazonFileKey : this.amazonFileKey,
        amazonDisplayFileName : this.amazonDisplayFileName,
        //fileSize : fileSize,
        url : this.url
    })
}
export type FileType="AMAZON"|"BOLK";